import { useEffect } from "react";
import type { UseFormReturn } from "react-hook-form";
import { useReservationStore } from "../../../stores/useReservationStore";
import { loadFormSession, clearFormSession } from "../utils/formPersistence";
import type { ReservationFormValues } from "../reservation-page.schema";

interface UseFormSessionRestoreParams {
  reset: UseFormReturn<ReservationFormValues>["reset"];
  onRestoreSelectedTickets?: (ids: number[]) => void;
}

export function useFormSessionRestore({
  reset,
  onRestoreSelectedTickets,
}: UseFormSessionRestoreParams) {
  const { reservationId, bulkRestore } = useReservationStore();

  useEffect(() => {
    if (!reservationId) return;
    const session = loadFormSession(reservationId);
    if (!session) return;
    clearFormSession(reservationId);

    bulkRestore(
      session.ticketPersonData,
      session.optionQuantities ?? {},
      session.ticketOptionQuantities ?? {},
    );

    reset(session.formValues, { keepDefaultValues: true });

    if (session.selectedTicketIds && onRestoreSelectedTickets) {
      onRestoreSelectedTickets(session.selectedTicketIds);
    }
  }, [reservationId]);
}
